import React from 'react';
import { connect } from 'react-redux';
import { Form, Label } from '@leverege/ui-elements';
import { UserValidator } from '@leverege/api-validator';
import { Validator } from '@leverege/validator';
import I18N from '@leverege/i18n';
import Rsrc from "../Rsrc.js";
import S from './User.css';
const {
  t
} = I18N.ns('userManagement.user.NewUserForm');

/**
 * Activate account screen.
 */
class NewUserForm extends React.Component {
  constructor(props) {
    super(props);

    // Get parameters
    const {
      onValueChange,
      validator
    } = props;
    const defaultCustomValidator = (data, result) => result;

    // Initialize validator. 
    this.validator = {
      fields: {
        ...Rsrc.activateAccountFieldValidators,
        email: {
          active: true,
          validator: email => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'email') {
              result = UserValidator.email(email, {
                isRequired: false
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.email?.validator || defaultCustomValidator;
            return customValidator(email, result);
          }
        },
        name: {
          active: true,
          validator: name => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'name') {
              result = UserValidator.name(name, {
                isRequired: false
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.name?.validator || defaultCustomValidator;
            return customValidator(name, result);
          }
        },
        phone: {
          active: true,
          validator: phone => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'phone') {
              result = UserValidator.phone(phone, {
                isRequired: false
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.phone?.validator || defaultCustomValidator;
            return customValidator(phone, result);
          }
        },
        username: {
          active: true,
          validator: username => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'username') {
              result = UserValidator.username(username, {
                isRequired: false
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.username?.validator || defaultCustomValidator;
            return customValidator(username, result);
          }
        },
        password: {
          active: true,
          validator: password => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'password') {
              result = UserValidator.password(password, {
                isRequired: false
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.password?.validator || defaultCustomValidator;
            return customValidator(password, result);
          }
        },
        confirmPassword: {
          active: true,
          validator: (confirmPassword, _, {
            password
          }) => {
            const activeInput = document.activeElement?.getAttribute('name');
            let result = null;
            if (activeInput !== 'confirmPassword' || confirmPassword?.length && password?.length && confirmPassword.length >= password.length) {
              result = UserValidator.confirmPassword(password, confirmPassword, {
                isRequired: false,
                waitForPassword: true
              });
            }
            const customValidator = Rsrc.activateAccountFieldValidators?.confirmPassword?.validator || defaultCustomValidator;
            return customValidator(confirmPassword, result);
          }
        }
      },
      validator(data) {
        if (typeof validator === 'function') {
          return validator(data);
        }
        return null;
      },
      onValueChange: (values, prevValues) => {
        if (typeof onValueChange === 'function') {
          onValueChange(values, prevValues);
        }
      }
    };
  }

  /**
   * Renders the form.
   */
  renderForm = validator => {
    // Get parameters
    const {
      error,
      roleSelector,
      type = 'invite',
      user,
      variants,
      onSubmit,
      submitText
    } = this.props;
    const isUsernameEmail = Validator.isEmail(user.username);

    // Return component
    return /*#__PURE__*/React.createElement("div", {
      className: S.gridContainer
    }, /*#__PURE__*/React.isValidElement(error) && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, error), type === 'invite' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.inviteEmailLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      hint: Rsrc.inviteEmailHint,
      name: "email",
      autoComplete: "email",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "email",
      alwaysTakeSpace: false
    })), /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.createPhoneLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      hint: Rsrc.createPhoneHint,
      type: "tel",
      name: "phone",
      autoComplete: "tel",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "phone",
      alwaysTakeSpace: false
    }))), type === 'create' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, isUsernameEmail ? Rsrc.createEmailLabel : Rsrc.createUsernameLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      name: "username",
      disabled: true,
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "username",
      alwaysTakeSpace: false
    })), !isUsernameEmail && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, t('email')), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      hint: Rsrc.createEmailHint,
      name: "email",
      autoComplete: "email",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "username",
      alwaysTakeSpace: false
    }))), type === 'activate' && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.activateEmailLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      name: "username",
      autoComplete: "username",
      disabled: true,
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "username",
      alwaysTakeSpace: false
    })), (type === 'create' || type === 'activate') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.createNameLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      hint: Rsrc.createNameHint,
      name: "name",
      autoComplete: "name",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "name",
      alwaysTakeSpace: false
    })), /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.createPhoneLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      hint: Rsrc.createPhoneHint,
      type: "tel",
      name: "phone",
      autoComplete: "tel",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "phone",
      alwaysTakeSpace: false
    })), /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.createPasswordLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      autoComplete: "new-password",
      hint: Rsrc.createPasswordHint,
      type: "password",
      name: "password",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "password",
      alwaysTakeSpace: false
    })), /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: variants?.inputLabel
    }, Rsrc.createConfirmPasswordLabel), /*#__PURE__*/React.createElement(Form.TextInput, {
      variant: variants?.textInput,
      autoComplete: "new-password",
      hint: Rsrc.createConfirmPasswordHint,
      type: "password",
      name: "confirmPassword",
      alwaysFireOnBlur: true
    }), /*#__PURE__*/React.createElement(Form.Error, {
      variant: variants?.inputCaption,
      name: "confirmPassword",
      alwaysTakeSpace: false
    }))), /*#__PURE__*/React.isValidElement(roleSelector) && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, roleSelector), Rsrc.activateAccountPreSubmitComponents, typeof onSubmit === 'function' && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, /*#__PURE__*/React.createElement(Form.Submit, {
      variant: variants?.submitButton
    }, submitText || t('submit'))));
  };

  /**
   * Renders the component.
   */
  render() {
    // Get parameters
    const {
      key,
      user,
      onSubmit
    } = this.props;

    // Return component
    return /*#__PURE__*/React.createElement(Form, {
      key: key,
      data: user,
      render: this.renderForm,
      validator: this.validator,
      onSubmit: onSubmit
    });
  }
}

/* Export and Connect Module */
export default connect(state => {
  return {
    auth: state.auth
  };
})(NewUserForm);